(function ($) {

  //    $('.announcementbar_row').slick({
  //   dots: false,
  //   infinite: true,
  //   speed: 300,
  //   slidesToShow: 1,
  //   autoplay: true,
  //   slidesToScroll: 1,
  //   arrows: true,
  //             prevArrow:"<button type='button' class='slick-prev pull-left'><img src='//abbottoaks.com/cdn/shop/t/105/assets/prev_arrow.svg?v=1657606240654518941785272815'></button>",
  //             nextArrow:"<button type='button' class='slick-next pull-right'><img src='//abbottoaks.com/cdn/shop/t/105/assets/next_arrow.svg?v=27791854107412609141785272815'></button>",
  // });

  $('.header__nav-button').click(function () {
    $('body').addClass('menu-open');

  });
  $('#search').on('keyup', function () {
    if (checkWindowWidth() < 576) {
      $('.close-search-results').css('display', 'block');
    }
  })
  $('.close-search-results').click(function () {
    $('#search').val('')
    $('.close-search-results').css('display', 'none');
  })
  $('.close-search-results').css('display', 'none');
  $('.close-btn').click(function () {
    $('body').removeClass('menu-open');

  });
  $('.page-overlay').click(function () {
    $('body').removeClass('menu-open');

  });

  $(".top-menu .nav-element.dropdown>a").attr("href", "javascript:;");
  $('.nav-element.dropdown>a').click(function () {
    $(this).toggleClass('open')
    $(this).next('.dropdown-menu').toggle(500)
  })

  $('.cart-i').click(function () {
    $('body').toggleClass('cart-open');

    var chat = document.getElementById('chat-button');
    if (chat) chat.classList.add('hidden');

    if (window.innerWidth < 992) {
      var ps = document.getElementById('ps__widget_container');
      if (ps) ps.classList.add('hidden');
    }
  });

  $(".search-icon").click(function () {
    $(".desk-search_wrap").addClass("active"),
      setTimeout(function () {
        $("#goal-input").focus();
      }, 500);
    $('body').addClass('no-scroll');
  }),

    $('.search-i').click(function () {
      $('.desk-search_wrap').removeClass('active');
      $('body').removeClass('no-scroll');
    })

  $('.page-overlay').click(function () {
    $('.desk-search_wrap').removeClass('active');
    $('body').removeClass('no-scroll');
  })

  $('.accordions>li>a').click(function () {
    $(this).parent('li').toggleClass('active');
  })


  $('.page-overlay').click(function () {
    $('body').removeClass('cart-open');
    var chat = document.getElementById('chat-button');
    var ps = document.getElementById('ps__widget_container'); 
    document.querySelectorAll('.chain_slideout_container.active').forEach(function (s) {
      s.classList.remove('active');
    });

    if (chat) chat.classList.remove('hidden');
    if (ps) ps.classList.remove('hidden');
  });

  $('.clos').click(function () {
    $('body').removeClass('cart-open');
    var chat = document.getElementById('chat-button');
    var ps = document.getElementById('ps__widget_container');
    if (chat) chat.classList.remove('hidden');
    if (ps) ps.classList.remove('hidden');
  });

  $('.tab-menu li a').on('click', function () {
    var target = $(this).attr('data-rel');
    $('.tab-menu li a').removeClass('active');
    $(this).addClass('active');
    $("#" + target).fadeIn('slow').siblings(".tab-box").hide();
    return false;
  });



  //   $('.col-list-slide').slick({
  //   dots: false,
  //   infinite: true,
  //   speed: 300,
  //   slidesToShow: 4,
  //   slidesToScroll: 4,
  //   arrows: true,
  //             prevArrow:"<button type='button' class='slick-prev pull-left'><img src='//abbottoaks.com/cdn/shop/t/105/assets/angle-prev-g.svg?v=141089530151728878891785272815'></button>",
  //             nextArrow:"<button type='button' class='slick-next pull-right'><img src='//abbottoaks.com/cdn/shop/t/105/assets/angle-next-g.svg?v=91939394160287207871785272815'></button>",
  //   responsive: [
  //     {
  //       breakpoint: 1024,
  //       settings: {
  //         slidesToShow: 3,
  //         slidesToScroll: 3,
  //         infinite: true,
  //         dots: false
  //       }
  //     },
  //     {
  //       breakpoint: 768,
  //      settings: "unslick"
  //     }
  //   ]
  // });



  // if ($(window).width() < 767) {
  //    $('.product-slider').slick({
  //      slidesToShow: 1,
  //      dots:true,
  //      arrows: false,
  //      responsive: [
  //        {
  //          breakpoint: 767,
  //          settings: {
  //            slidesToShow: 1
  //          }
  //        },
  //        {
  //          breakpoint: 480,
  //          settings: {
  //            centerMode: false,
  //            centerPadding: '0px',
  //            slidesToShow: 1
  //          }
  //        }
  //     ]
  //   });
  // }

  //   var swiper = new Swiper('.swiper-container', {
  //        pagination: '.swiper-pagination',
  //        direction: 'vertical',
  //         //slidesPerView: 1,
  //        initialSlide: 1,
  //        paginationClickable: true,
  //     centeredSlides: true,
  //      slidesPerView: "auto",
  //      spaceBetween: 5,
  //        mousewheelControl: true,
  //        parallax: true,
  //     autoHeight: true,
  //        speed: 600,
  //      breakpoints: {
  //      768: {
  //         initialSlide: 0,
  //        centeredSlides: false,
  //        slidesPerView: 1,
  //        spaceBetween: 0,
  //        parallax: false,
  //        mousewheelControl: false,
  //        direction: 'horizontal'
  //      }
  //    }
  // });

  // function verticallyCenterSlide(api) {
  //              var activeSlide = api.slides[api.activeIndex];
  //              var top = ($(api.container).height() - $(activeSlide).height()) / 2;
  //              $(activeSlide).css("top", ""+top+"px");
  //          }
  $(window).on('load', function () {


    var now, lastDatePopupShowed;
    now = new Date();

    if (localStorage.getItem('lastDatePopupShowed') !== null) {
      lastDatePopupShowed = new Date(parseInt(localStorage.getItem('lastDatePopupShowed')));
    }

    if (((now - lastDatePopupShowed) >= (15 * 86400000)) || !lastDatePopupShowed) {
      setTimeout(function () {
        if (jQuery('#Newsletter-Popup').length) {
          jQuery.magnificPopup.open({
            items: {
              src: '#Newsletter-Popup'
            },
            type: 'inline'

          });
        }
      }, 1050);

      localStorage.setItem('lastDatePopupShowed', now);


    }



  });



  $(document).on('click', '.closePopup', function (e) {
    e.preventDefault();
    $.magnificPopup.close();
  });


  $('.select-toggle').click(function () {
    $(this).next('.dropdown-menu').toggleClass('active');
  });
  $('.select-dropdown .dropdown-menu button').on('click', function () {
    var getValue = $(this).text();
    $('.select-dropdown .dropdown-menu>button').removeClass("active");
    $(this).addClass("active");
    $('.select-dropdown .dropdown-menu').removeClass("active");
  });
  $(".select-dropdown .dropdown-menu button ").click(function () {
    $(this).closest('.select-dropdown').find('.select-toggle ').text($(this).text());
  });

  $('body').click(function () {
    $('.select-dropdown .dropdown-menu').removeClass("active");
  });

  $('.select-toggle').click(function (event) {
    event.stopPropagation();
  });



  $('.filter-link').click(function () {
    $('.collection-sidebar').toggleClass('active');
    $('body').toggleClass('filters-open');
  });


  $(function () {
    $('.product-info ul.accordion li a').trigger('click');
  });


  $('.page-overlay').click(function () {
    $('.collection-sidebar').removeClass('active');
    $('body').removeClass('filters-open');
  });
  $('.close-f').click(function () {
    $('.collection-sidebar').removeClass('active');
    $('body').removeClass('filters-open');
  });
  $('.close-filter').click(function () {
    $('.collection-sidebar').removeClass('active');
    $('body').removeClass('filters-open');
  });


  $(window).scroll(function () {
    if ($(this).scrollTop() > 40) {
      $('body').addClass("sticky");
    }
    else {
      $('body').removeClass("sticky");
    }
  });




})(jQuery);

function openpopup(url, name) {
  window.open(url, name, 'width=500,height=300');
}


function a(t, e) {
  (window.observer = new IntersectionObserver(o, { root: null, threshold: 0.7 })),
    $(t, e).each(function (t, e) {
      window.observer.observe(e);
    });
}

$('.primary-images-dots li').on('click', function () {
  var target = $(this).attr('data-rel');
  var parentScroll = $('.product-slider').scrollTop();
  var parentOffset = $('.product-slider').offset().top;
  console.log($("#" + target).offset().top);
  $('.primary-images-dots li').removeClass('selected');
  $(this).addClass('selected');
  $('.product-slider').animate({
    scrollTop: parentScroll - parentOffset + $("#" + target).offset().top
  }, 500, function () {


  });


});
$(document).ready(function () {
  $('a:contains("DETAILS"), a:contains("MEASUREMENTS")').each(function () {
    // Find the sibling <div> that contains the <span> with the metafield-multi_line_text_field class
    $(this).siblings('div').find('.metafield-multi_line_text_field').each(function () {
      // Get the current HTML content of the element
      var content = $(this).html();

      // Add a double <br> only if there isn't already a consecutive <br>
      content = content.replace(/(<br\s*\/?>)(?!<br\s*\/?>)/gi, '$1<br>');

      // Update the element with the modified content
      $(this).html(content);
    });
  });

});

$(window).resize(function () {
  if (checkWindowWidth() > 576) {
    $('.close-search-results').css('display', 'none');
  }

  if (checkWindowWidth() > 767) {
    // $('.product-wrap-sold .product-slider').slick('unslick');
    $('#vintage-difference .vintage').removeClass('container')
    $('.product').addClass('container-fluid')
    $('.product').removeClass('container')
  } else {
    $('#vintage-difference .vintage').addClass('container')
    $('.product').removeClass('container-fluid')
    $('.product').addClass('container')
  }
});
function checkWindowWidth() {
  return $(window).width();
}
//scrollTop: n.scrollTop() - n.offset().top + r.offset().top 

// function debounce(func, wait, immediate) {
// 	var timeout;
// 	return function() {
// 		var context = this, args = arguments;
// 		var later = function() {
// 			timeout = null;
// 			if (!immediate) func.apply(context, args);
// 		};
// 		var callNow = immediate && !timeout;
// 		clearTimeout(timeout);
// 		timeout = setTimeout(later, wait);
// 		if (callNow) func.apply(context, args);
// 	};
// };


// function slick_handle_wheel_event(e, slick_instance, slick_is_animating) {

//   if (!slick_is_animating) {

//     var direction =
//       Math.abs(e.deltaX) > Math.abs(e.deltaY) ? e.deltaX : e.deltaY;

//     console.log("wheel scroll ", e.deltaX, e.deltaY, direction);

//     if (direction > 0) {

//       slick_instance.slick("slickNext");
//     } else {

//       slick_instance.slick("slickPrev");
//     }
//   }
// }


// var slick_handle_wheel_event_debounced = debounce( 
//   slick_handle_wheel_event
//   , 100, true
// );

// init slider 
// const slick_2 = $(".product-slider");
// slick_2.slick({
//   dots: true,
//   vertical: true,
//   infinite: false,
//   centerMode: true,
//   centerPadding: '150px',
//   slidesToShow: 1,
//   verticalSwiping: true,
//   arrows: false,
//     responsive: [
//     {
//       breakpoint: 767,
//       settings: {
//         centerMode: false,
//         vertical:false,
//         verticalSwiping:false,
//         centerPadding: '0px',
//         slidesToShow: 1
//       }
//     },
//     {
//       breakpoint: 480,
//       settings: {
//         centerMode: false,
//         vertical:false,
//         verticalSwiping:false,
//         centerPadding: '0px',
//         slidesToShow: 1
//       }
//     }
//   ]
// });
//  var slick_2_is_animating = false;



// slick_2.on("afterChange", function(index) {
//   console.log("Slide after change " + index);
//   slick_2_is_animating = false;
// });

// slick_2.on("beforeChange", function(index) {
//   console.log("Slide before change " + index);
//   slick_2_is_animating = true;
// });

// slick_2.on("wheel", function(e) {
//   slick_handle_wheel_event_debounced(e.originalEvent, slick_2, slick_2_is_animating);  
// });

// function HeaderH() {
//   var HeaderHeight = $('#header').height();
//   $('.sticky .side-cart').css('top', HeaderHeight + 'px');
// }


//  $(document).ready(function(){
//    HeaderH();

//  });

// $(window).resize(function(){
//   HeaderH();
// });
// $(window).scroll(function(){
//   HeaderH();
// });

$('#drop-a-hint-form').on('submit', function (e) {
  e.preventDefault();

  var form = $(this)[0];
  var formData = new FormData(form);
  var data = {};

  formData.forEach(function (value, key) {
    data[key.trim()] = value.trim();
  });


  //console.log(data);
  if (!data.your_email || !data.recipient_email) {
    console.error('Required fields are missing.');
    return;
  }
  // try{
  //           if (typeof _learnq !== 'undefined' && typeof _learnq.push === 'function') { 
  //             // _learnq.push(['identify', {
  //             //   'Email': data.recipient_email
  //             // }]);
  //             // Track event
  //             _learnq.push(['track', 'Drop a Hint Submitted', {
  //                 '$email': data.recipient_email,
  //                 "Your Email": data.your_email || '',
  //                 "Your Name": data.your_name || '',
  //                 "Recipient Email": data.recipient_email || '',
  //                 "Message": data.your_message || '',
  //                 "Product Name": data.product_name || '',
  //                 "Product Price": data.product_price || '',
  //                 "Product URL": data.product_url || '',
  //                 "Product Image": data.product_image ? "https:" + data.product_image : '',
  //                 "Form Version": "v1.0.0"
  //             }]);
  //             console.log('Track event pushed');
  //         } else {
  //             console.error('Klaviyo is not loaded correctly.');
  //         }
  // } catch (error){
  //   console.error('Unexpected error with _learnq.push:', error);
  // }   

  // console.log('Data:', data);
  console.log('JSON:', JSON.stringify(data));

  fetch('https://digitality.ba/klaviyo.php', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  })
    .then(response => {
      console.log('Status:', response.status);
      return response.text();
    })
    .then(result => {
      console.log('Server response:', result);
    })
    .catch(error => {
      console.error('Error sending data to server:', error);
    });


  form.reset();
  $('.modal-submit-btn').blur();
  $('#exampleModal').modal('hide');
});




// $('.collection-list').slick({
//   centerMode: true,
//   centerPadding: '120px',
//   slidesToShow: 3,
//   dots:false,
//   arrows: true,
//   prevArrow:"<button type='button' class='slick-prev pull-left'><img src='//abbottoaks.com/cdn/shop/t/105/assets/angle-prev-g.svg?v=141089530151728878891785272815'></button>",
//   nextArrow:"<button type='button' class='slick-next pull-right'><img src=//abbottoaks.com/cdn/shop/t/105/assets/angle-next-g.svg?v=91939394160287207871785272815'></button>",
//   responsive: [
//     {
//       breakpoint: 768,
//       settings: {
//         arrows: false,
//         centerMode: true,
//         centerPadding: '80px',
//         slidesToShow: 3
//       }
//     },
//     {
//       breakpoint: 600,
//       settings: {
//         slidesToShow: 2,
//         slidesToScroll: 2,
//         centerMode: true,
//         centerPadding: '40px',
//         arrows: false,
//         dots: false
//       }
//     },
//     {
//       breakpoint: 480,
//       settings: {
//         arrows: false,
//         centerMode: true,
//         centerPadding: '40px',
//         slidesToShow: 1
//       }
//     }
//   ]
// });

// $('.collection-slide').slick({
//   dots: false,
//   infinite: true,
//   speed: 300,
//   slidesToShow: 5,
//   slidesToScroll: 5,
//   arrows: true,
//             prevArrow:"<button type='button' class='slick-prev pull-left'><img src='//abbottoaks.com/cdn/shop/t/105/assets/angle-prev-g.svg?v=141089530151728878891785272815'></button>",
//             nextArrow:"<button type='button' class='slick-next pull-right'><img src='//abbottoaks.com/cdn/shop/t/105/assets/angle-next-g.svg?v=91939394160287207871785272815'></button>",
//   responsive: [
//     {
//       breakpoint: 1024,
//       settings: {
//         slidesToShow: 3,
//         slidesToScroll: 3,
//         infinite: true,
//         dots: false
//       }
//     },
//     {
//       breakpoint: 600,
//       settings: {
//         slidesToShow: 2,
//         slidesToScroll: 2,
//         centerMode: true,
//         centerPadding: '60px',
//         arrows: false,
//         dots: false
//       }
//     },
//     {
//       breakpoint: 480,
//       settings: {
//         slidesToShow: 1,
//         slidesToScroll: 1,
//         centerMode: true,
//         centerPadding: '60px',
//         arrows: false,
//         dots: false
//       }
//     }

//   ]
// });


AOS.init();




